import React from 'react';
import { AdminUsersPanel } from '../../../components/AdminUsersPanel';
export const UsersPanel = ({ venue }) => {
  return <AdminUsersPanel users={venue.users} />;
};
